module.exports = __webpack_public_path__ + "img/icon-wechat.fdcf42c7.svg";